export default "__VITE_ASSET__CzG4jouK__"